<script setup>
import {
  computed,
} from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import {
  KkModal,
  KkLoading
} from '../../../base'

const store = useStore()
const { t } = useI18n()

const props = defineProps({
  showLoadingModal: {
    type: Boolean,
    default: false
  },
  completed: {
    type: Boolean,
    default: false
  },
  failed: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['close-loading-modal'])

const submitActionModalType = computed(() => store.getters['companiesStoreSnsPosts/submitActionModalType'])

const loadingMessage = computed(() => {
  switch(submitActionModalType.value) {
  case 'draft':
    return t('pages.CompaniesStoreSnsPost.form.loadingModal.loading.draft')
  case 'request' :
    return t('pages.CompaniesStoreSnsPost.form.loadingModal.loading.request')
  default:
    return t('pages.CompaniesStoreSnsPost.form.loadingModal.loading.post')
  }
})

const completedMessage = computed(() => {
  switch(submitActionModalType.value) {
  case 'draft':
    return t('pages.CompaniesStoreSnsPost.form.loadingModal.completed.draft')
  case 'request' :
    return t('pages.CompaniesStoreSnsPost.form.loadingModal.completed.request')
  default:
    return t('pages.CompaniesStoreSnsPost.form.loadingModal.completed.post')
  }
})

const failedMessage = computed(() => {
  switch(submitActionModalType.value) {
  case 'draft':
    return t('pages.CompaniesStoreSnsPost.form.loadingModal.failed.draft')
  case 'request' :
    return t('pages.CompaniesStoreSnsPost.form.loadingModal.failed.request')
  default:
    return t('pages.CompaniesStoreSnsPost.form.loadingModal.failed.post')
  }
})

</script>

<template>
  <KkModal :is-visible="props.showLoadingModal" @change="emit('close-loading-modal')">
    <div v-show="!props.completed && !props.failed">
      <p class="text">
        {{ loadingMessage }}
      </p>

      <KkLoading />
    </div>

    <div v-show="props.completed" class="completed">
      <p class="text">
        {{ completedMessage }}
      </p>
    </div>

    <div v-show="props.failed" class="completed">
      <p class="text">
        {{ failedMessage }}
      </p>
    </div>
  </KkModal>
</template>

<style lang="scss" scoped>
.text {
  padding-top: 48px;
  text-align: center;
  font-weight: bold;
  white-space: pre-line;
}

.completed .text {
  padding: 48px 0;
}

</style>
